import axios from "axios";
import alert from "@/lang/AlertMessages.js";
import label from "@/lang/StaticLabels.js";
import router from "@/router";
import { EventBus } from "@/plugins/eventBus";
const baseUrl = "base/api/v1/";

const parsinaSupportXios = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
});
parsinaSupportXios.headers = { "Accept-language": "en-US" };
parsinaSupportXios.defaults.headers.common["Content-Type"] = "application/json";
parsinaSupportXios.defaults.headers.common["Authorization"] =
  localStorage.mitaParsinaSupportToken;

export default {
  // Members Authentications -------------------------------------------------------
  login({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(baseUrl + "parsina/ParsinaAccount", data)
      .then((res) => {
        commit("authUser", res.data);
        localStorage.setItem("mitaParsinaSupportToken", res.data.data.token);
        parsinaSupportXios.defaults.headers.common["Authorization"] =
          res.data.data.token;
        router.push({ name: "PPARSINADashboard" });
        EventBus.$emit("user-logged-in");
        setTimeout(() => {
          commit("setSuccess", alert.success.login, { root: true });
        }, 800);
      })
      .catch((error) => {
        dispatch("errorPOSTHandlerSupport", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  logout() {
    localStorage.removeItem("mitaParsinaSupportToken");
    parsinaSupportXios.defaults.headers.common["Authorization"] = "";
    router.push({ name: "parsinaSupportLogin" });
  },

  // Upload Actions ------------------------------------------------------------------
  addUpload({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    parsinaSupportXios
      .post("filing/api/v1/Upload", data)
      .then((res) => {
        commit("setUploadInfo", res.data.data);
        dispatch(
          "successPOSTHandlerSilent",
          {
            server: res,
            message: alert.success.save,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getUploads({ dispatch, commit }, data) {
    parsinaSupportXios
      .get("filing/api/v1/Upload/GetDefaults/" + data)
      .then((res) => {
        commit("setUploads", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getUploadsBy({ dispatch }, data) {
    return parsinaSupportXios
      .get("filing/api/v1/Upload/GetDefaults?" + data)
      .then((res) => res.data.data || [])
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
        return [];
      });
  },

  // DropDown Actions ------------------------------------------------------------------
  getSubSystems({ dispatch, commit }) {
    parsinaSupportXios
      .get("base/api/v1/parsina/DropDown/SubSystems")
      .then((res) => {
        commit("setSubSystems", res.data.data);
      })
      .catch((error) => {
        dispatch("errorPOSTHandlerSupport", error, { root: true });
      });
  },

  getCompanyTypes({ dispatch, commit }) {
    parsinaSupportXios
      .get("base/api/v1/parsina/DropDown/CompanyTypes")
      .then((res) => {
        commit("setCompanyTypes", res.data.data);
      })
      .catch((error) => {
        dispatch("errorPOSTHandlerSupport", error, { root: true });
      });
  },

  // Company Actions ------------------------------------------------------------------
  getCompanies({ dispatch, commit }) {
    parsinaSupportXios
      .get(baseUrl + "parsina/Company")
      .then((res) => {
        commit("setCompanies", res.data.data);
      })
      .catch((error) => {
        dispatch("errorPOSTHandlerSupport", error, { root: true });
      });
  },

  getCompany({ dispatch, commit }, data) {
    parsinaSupportXios
      .get(baseUrl + "parsina/Company/" + data)
      .then((res) => {
        commit("setCompany", res.data);
      })
      .catch((error) => {
        dispatch("errorPOSTHandlerSupport", error, { root: true });
      });
  },

  addCompany({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    parsinaSupportXios
      .post(baseUrl + "parsina/Company", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandlerSupport", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editCompany({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    parsinaSupportXios
      .put(baseUrl + "parsina/Company/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandlerSupport", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteCompany({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    parsinaSupportXios
      .delete(baseUrl + "parsina/Company/" + data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandlerSupport", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  // RelationField Actions ------------------------------------------------------------
  getRelationFields({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    parsinaSupportXios
      .get(baseUrl + "parsina/RelationField" + (data ? "?" + data : ""))
      .then((res) => {
        commit("setRelationFields", res.data.data);
      })
      .catch((error) => {
        dispatch("errorPOSTHandlerSupport", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  upsertRelationField({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    parsinaSupportXios
      .post(baseUrl + "parsina/RelationField/Upsert", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message || alert.success.save,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandlerSupport", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  discoverRelationFields({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    parsinaSupportXios
      .post(baseUrl + "parsina/RelationField/Discover", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message || alert.success.save,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandlerSupport", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  initializeRelationFields({ dispatch, commit }) {
    commit("setLoadingBtn", true, { root: true });
    parsinaSupportXios
      .post(baseUrl + "parsina/RelationField/Initialize", {})
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message || alert.success.save,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandlerSupport", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editRelationFieldDeleteBehavior({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    parsinaSupportXios
      .put(
        baseUrl + "parsina/RelationField/UpdateDeleteBehavior/" + data.id,
        data.value,
      )
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message || alert.success.edit,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandlerSupport", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteRelationFields({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    parsinaSupportXios
      .delete(baseUrl + "parsina/RelationField", { data })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message || alert.success.delete,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandlerSupport", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getRelationTables({ dispatch, commit }, data) {
    parsinaSupportXios
      .get(baseUrl + "parsina/RelationField/Tables?"+ data)
      .then((res) => {
        commit("setRelationTables", res.data.data);
      })
      .catch((error) => {
        dispatch("errorPOSTHandlerSupport", error, { root: true });
      });
  },

  getRelationForeignKeys({ dispatch, commit }) {
    parsinaSupportXios
      .get(baseUrl + "parsina/RelationField/ForeignKeys")
      .then((res) => {
        commit("setRelationForeignKeys", res.data.data);
      })
      .catch((error) => {
        dispatch("errorPOSTHandlerSupport", error, { root: true });
      });
  },

  // لیست‌های زیر مخصوص فیلتر جستجو هستند و با انتخاب پایگاه داده والد/فرزند
  // (DbEnumId) و جدول والد (TableName) محدود می‌شوند.
  getRelationParentTables({ dispatch, commit }, data) {
    parsinaSupportXios
      .get(baseUrl + "parsina/RelationField/Tables" + (data ? "?" + data : ""))
      .then((res) => {
        commit("setRelationParentTables", res.data.data);
      })
      .catch((error) => {
        dispatch("errorPOSTHandlerSupport", error, { root: true });
      });
  },

  getRelationChildTables({ dispatch, commit }, data) {
    parsinaSupportXios
      .get(baseUrl + "parsina/RelationField/Tables" + (data ? "?" + data : ""))
      .then((res) => {
        commit("setRelationChildTables", res.data.data);
      })
      .catch((error) => {
        dispatch("errorPOSTHandlerSupport", error, { root: true });
      });
  },

  getRelationParentForeignKeys({ dispatch, commit }, data) {
    parsinaSupportXios
      .get(
        baseUrl + "parsina/RelationField/ForeignKeys" + (data ? "?" + data : ""),
      )
      .then((res) => {
        commit("setRelationParentForeignKeys", res.data.data);
      })
      .catch((error) => {
        dispatch("errorPOSTHandlerSupport", error, { root: true });
      });
  },

  getDatabases({ dispatch, commit }) {
    parsinaSupportXios
      .get(baseUrl + "parsina/RelationField/DataBases")
      .then((res) => {
        commit("setDatabases", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
  // Menu Actions ----------------------------------------------------------------------
  // لیست برگردانده می‌شود و صفحه خودش setMenus را می‌زند تا پاسخ دیررسیده‌ی یک
  // زیرسیستم دیگر روی لیست فعلی ننشیند.
  getMenus({ dispatch }, data) {
    return parsinaSupportXios
      .get(baseUrl + "parsina/Menu" + (data ? "?" + data : ""))
      .then((res) => res.data.data || [])
      .catch((error) => {
        dispatch("errorPOSTHandlerSupport", error, { root: true });
        return null;
      });
  },

  // فرم ویرایش از همین سرویس پر می‌شود چون PUT همه‌ی فیلدها را می‌خواهد.
  getMenu({ dispatch }, data) {
    return parsinaSupportXios
      .get(baseUrl + "parsina/Menu/" + data)
      .then((res) => res.data.data)
      .catch((error) => {
        dispatch("errorPOSTHandlerSupport", error, { root: true });
        return null;
      });
  },

  editMenu({ dispatch }, data) {
    return parsinaSupportXios
      .put(baseUrl + "parsina/Menu/" + data.id, data.value)
      .then((res) => res.data || {})
      .catch((error) => {
        dispatch("errorPOSTHandlerSupport", error, { root: true });
        return null;
      });
  },

  // Market Item Actions (درخت نمادهای ویجت قیمت tgju) --------------------------------
  // لیست تخت برمی‌گردد و صفحه خودش درخت را با parentId می‌سازد.
  getMarketItems({ dispatch }) {
    return parsinaSupportXios
      .get(baseUrl + "parsina/MarketItem")
      .then((res) => res.data.data || [])
      .catch((error) => {
        dispatch("errorPOSTHandlerSupport", error, { root: true });
        return null;
      });
  },

  // ساختار درخت (children تودرتو)؛ priority و isDefault و parentId ندارد و با لیست تخت تکمیل می‌شود.
  getMarketItemTree({ dispatch }) {
    return parsinaSupportXios
      .get(baseUrl + "MarketItem/Tree")
      .then((res) => res.data.data || [])
      .catch((error) => {
        dispatch("errorPOSTHandlerSupport", error, { root: true });
        return null;
      });
  },

  getMarketItem({ dispatch }, data) {
    return parsinaSupportXios
      .get(baseUrl + "parsina/MarketItem/" + data)
      .then((res) => res.data.data)
      .catch((error) => {
        dispatch("errorPOSTHandlerSupport", error, { root: true });
        return null;
      });
  },

  // خروجی شناسه‌ی نود جدید است.
  addMarketItem({ dispatch }, data) {
    return parsinaSupportXios
      .post(baseUrl + "parsina/MarketItem", data)
      .then((res) => res.data || {})
      .catch((error) => {
        dispatch("errorPOSTHandlerSupport", error, { root: true });
        return null;
      });
  },

  // UpdateMarketItemCommand شناسه را در بدنه هم می‌خواهد.
  editMarketItem({ dispatch }, data) {
    return parsinaSupportXios
      .put(baseUrl + "parsina/MarketItem/" + data.id, { ...data.value, id: data.id })
      .then((res) => res.data || {})
      .catch((error) => {
        dispatch("errorPOSTHandlerSupport", error, { root: true });
        return null;
      });
  },

  deleteMarketItem({ dispatch }, data) {
    return parsinaSupportXios
      .delete(baseUrl + "parsina/MarketItem/" + data)
      .then((res) => res.data || {})
      .catch((error) => {
        dispatch("errorPOSTHandlerSupport", error, { root: true });
        return null;
      });
  },

  getClubPermissions({ dispatch, commit }) {
    parsinaSupportXios
      .get(baseUrl + "DropDown/ClubPermissions")
      .then((res) => {
        commit("setClubPermissions", res.data.data);
      })
      .catch((error) => {
        dispatch("errorPOSTHandlerSupport", error, { root: true });
      });
  },

  // Report Actions (چاپ‌های استیمول) ---------------------------------------------------
  // لیست گزارش‌های همه‌ی شعبه‌ها را برمی‌گرداند و branchName برای گزارش شعبه پر است.
  // لیست برگردانده می‌شود تا پاسخ دیررسیده‌ی یک فیلتر دیگر روی لیست فعلی ننشیند.
  getReports({ dispatch }, data) {
    return parsinaSupportXios
      .get(baseUrl + "parsina/Report" + (data ? "?" + data : ""))
      .then((res) => res.data.data || [])
      .catch((error) => {
        dispatch("errorPOSTHandlerSupport", error, { root: true });
        return null;
      });
  },

  // خروجی data شناسه‌ی گزارش جدید است تا دیزاینر همان گزارش باز شود.
  addReport({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    return parsinaSupportXios
      .post(baseUrl + "parsina/Report", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message || alert.success.save,
            redirect: false,
          },
          { root: true },
        );
        return res.data.data;
      })
      .catch((error) => {
        dispatch("errorPOSTHandlerSupport", error, { root: true });
        return null;
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  // برای تغییر نام فقط title فرستاده می‌شود.
  editReport({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    parsinaSupportXios
      .put(baseUrl + "parsina/Report/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message || alert.success.save,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandlerSupport", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  copyReport({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    parsinaSupportXios
      .post(baseUrl + "parsina/Report/Copy", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message || alert.success.save,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandlerSupport", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  // گزارش پیش‌فرض هم حذف می‌شود؛ اگر یک شناسه ایراد داشته باشد هیچ‌کدام حذف نمی‌شوند.
  deleteReports({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    parsinaSupportXios
      .delete(baseUrl + "parsina/Report", { data: [].concat(data) })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message || alert.success.delete,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandlerSupport", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  exportReports({ dispatch, commit }, data) {
    const params = new URLSearchParams();
    (data || []).forEach((id) => params.append("ids", String(id)));
    commit("setLoadingBtn", true, { root: true });
    return parsinaSupportXios
      .get(baseUrl + "parsina/Report/Export?" + params.toString(), {
        responseType: "blob",
        timeout: 0,
        maxContentLength: Infinity,
      })
      .then((res) => {
        const disposition = res.headers["content-disposition"] || "";
        const matched = /filename\*?=(?:UTF-8'')?"?([^";]+)"?/i.exec(
          disposition,
        );
        const fileName = matched
          ? decodeURIComponent(matched[1].trim())
          : "Reports.json";
        const blob = new Blob([res.data], { type: "application/json" });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      })
      .catch((error) => {
        // بدنه‌ی خطا هم blob است، پس پیام سرور باید از متن آن خوانده شود.
        const body = error.response && error.response.data;
        const readMessage =
          body instanceof Blob
            ? body.text().then((text) => {
                try {
                  return JSON.parse(text).message;
                } catch (e) {
                  return "";
                }
              })
            : Promise.resolve(body && body.message);
        return readMessage
          .catch(() => "")
          .then((message) => {
            if (error.response && error.response.status === 401) {
              return dispatch("logout");
            }
            commit(
              "setError",
              error.response && error.response.status === 403
                ? alert.error.access
                : message || label.reportManager.exportFailed,
              { root: true },
            );
          });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  // ورود همه یا هیچ است؛ خروجی لیست { id, title, isNew } چاپ‌های مقصد است.
  importReports({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    return parsinaSupportXios
      .post(baseUrl + "parsina/Report/Import", data, {
        timeout: 0,
        maxBodyLength: Infinity,
        maxContentLength: Infinity,
      })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message || alert.success.save,
            redirect: false,
          },
          { root: true },
        );
        return res.data.data || [];
      })
      .catch((error) => {
        dispatch("errorPOSTHandlerSupport", error, { root: true });
        return null;
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  // Backup Import Actions -------------------------------------------------------------
  getTargetBranches({ dispatch, commit }, data) {
    commit("setTargetBranches", []);
    if (!data) return;
    parsinaSupportXios
      .get(baseUrl + "parsina/DropDown/Branches?companyId=" + data)
      .then((res) => {
        commit("setTargetBranches", res.data.data);
      })
      .catch((error) => {
        dispatch("errorPOSTHandlerSupport", error, { root: true });
      });
  },

  getSourceBranches({ dispatch, commit }, data) {
    commit("setSourceBranches", []);
    if (!data) return;
    parsinaSupportXios
      .get(baseUrl + "parsina/DropDown/Branches?companyId=" + data)
      .then((res) => {
        commit("setSourceBranches", res.data.data);
      })
      .catch((error) => {
        dispatch("errorPOSTHandlerSupport", error, { root: true });
      });
  },

  startBackupImport({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    commit("setBackupUploading", true);
    commit("setBackupUploadProgress", 0);
    commit("setBackupImport", null);
    commit("setBackupImportId", null);
    return parsinaSupportXios
      .post(baseUrl + "parsina/BackupImport/Start", data, {
        timeout: 0,
        maxBodyLength: Infinity,
        maxContentLength: Infinity,
        onUploadProgress: (event) => {
          if (event.total) {
            commit(
              "setBackupUploadProgress",
              Math.round((event.loaded * 100) / event.total),
            );
          }
        },
      })
      .then((res) => {
        const started = (res.data && res.data.data) || {};
        commit("setBackupImportId", started.importId);
        commit("setBackupImport", {
          id: started.importId,
          status: 0,
          currentStep: null,
          error: null,
          fiscalYearMaps: [],
          modules: [],
          log: [],
        });
        return started.importId;
      })
      .catch((error) => {
        dispatch("errorPOSTHandlerSupport", error, { root: true });
      })
      .finally(() => {
        commit("setBackupUploading", false);
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getBackupImportStatus({ commit }, data) {
    return parsinaSupportXios
      .get(baseUrl + "parsina/BackupImport/Status/" + data)
      .then((res) => {
        commit("setBackupImport", res.data.data);
        return res.data.data;
      });
  },

  // Windows Backup Import Actions -----------------------------------------------------
  getWinTargetBranches({ dispatch, commit }, data) {
    commit("setWinTargetBranches", []);
    if (!data) return Promise.resolve([]);
    return parsinaSupportXios
      .get(baseUrl + "parsina/DropDown/Branches?companyId=" + data)
      .then((res) => {
        commit("setWinTargetBranches", res.data.data || []);
        return res.data.data || [];
      })
      .catch((error) => {
        dispatch("errorPOSTHandlerSupport", error, { root: true });
        return [];
      });
  },

  startWinBackupImport({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    commit("setWinBackupUploading", true);
    commit("setWinBackupUploadProgress", 0);
    return parsinaSupportXios
      .post(baseUrl + "parsina/WinBackupImport/Start", data, {
        timeout: 0,
        maxBodyLength: Infinity,
        maxContentLength: Infinity,
        onUploadProgress: (event) => {
          if (event.total) {
            commit(
              "setWinBackupUploadProgress",
              Math.round((event.loaded * 100) / event.total),
            );
          }
        },
      })
      .then((res) => {
        const started = (res.data && res.data.data) || {};
        if (!started.importId) {
          if (res.data && res.data.message) {
            commit("setError", res.data.message, { root: true });
          }
          return null;
        }
        return started.importId;
      })
      .catch((error) => {
        dispatch("errorPOSTHandlerSupport", error, { root: true });
        return null;
      })
      .finally(() => {
        commit("setWinBackupUploading", false);
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  // اگر شناسه ناشناخته باشد یا سرور ری‌استارت شده باشد، data برابر null است.
  getWinBackupImportStatus({ commit }, data) {
    return parsinaSupportXios
      .get(baseUrl + "parsina/WinBackupImport/Status/" + data)
      .then((res) => {
        const state = (res.data && res.data.data) || null;
        commit("setWinBackupImport", state);
        return state;
      });
  },

  cancelWinBackupImport({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    return parsinaSupportXios
      .post(baseUrl + "parsina/WinBackupImport/Cancel/" + data)
      .then(() => true)
      .catch((error) => {
        dispatch("errorPOSTHandlerSupport", error, { root: true });
        return false;
      })
      .finally(() => {
        commit("setLoadingBtn", false, { root: true });
      });
  },

  deleteWinBackupCreatedBranches({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    return parsinaSupportXios
      .post(baseUrl + "parsina/WinBackupImport/DeleteCreatedBranches/" + data)
      .then((res) => (res.data && res.data.data) || [])
      .catch((error) => {
        dispatch("errorPOSTHandlerSupport", error, { root: true });
        return null;
      })
      .finally(() => {
        commit("setLoadingBtn", false, { root: true });
      });
  },

  // Backup Export Actions -------------------------------------------------------------
  // شعبه‌های چند شرکت؛ برای هر شرکت جدا صدا زده و نتیجه‌ها با شناسه‌ی شرکت جمع می‌شوند.
  getExportBranches({ dispatch, commit }, data) {
    const companyIds = data || [];
    if (!companyIds.length) {
      commit("setExportBranches", []);
      return Promise.resolve([]);
    }
    return Promise.all(
      companyIds.map((companyId) =>
        parsinaSupportXios
          .get(baseUrl + "parsina/DropDown/Branches?companyId=" + companyId)
          .then((res) =>
            (res.data.data || []).map((item) => ({ ...item, companyId })),
          ),
      ),
    )
      .then((lists) => {
        const branches = [].concat(...lists);
        commit("setExportBranches", branches);
        return branches;
      })
      .catch((error) => {
        dispatch("errorPOSTHandlerSupport", error, { root: true });
        return [];
      });
  },

  downloadBackupScript({ commit }, data) {
    const filters = data || {};
    const params = new URLSearchParams();
    (filters.companyIds || []).forEach((id) =>
      params.append("CompanyIds", String(id)),
    );
    (filters.branchIds || []).forEach((id) =>
      params.append("BranchIds", String(id)),
    );
    (filters.fiscalYearIds || []).forEach((id) =>
      params.append("FiscalYearIds", String(id)),
    );
    const query = params.toString();
    commit("setBackupExporting", true);
    commit("setLoadingBtn", true, { root: true });
    return parsinaSupportXios
      .get(
        baseUrl + "parsina/BackupExport/Download" + (query ? "?" + query : ""),
        {
          responseType: "blob",
          timeout: 0,
          maxContentLength: Infinity,
        },
      )
      .then((res) => {
        const disposition = res.headers["content-disposition"] || "";
        const matched = /filename\*?=(?:UTF-8'')?"?([^";]+)"?/i.exec(
          disposition,
        );
        const fileName = matched
          ? decodeURIComponent(matched[1].trim())
          : "Mita-script.zip";
        const blob = new Blob([res.data], { type: "application/zip" });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      })
      .catch((error) => {
        // بدنه‌ی خطا هم blob است، پس پیام سرور باید از متن آن خوانده شود.
        const body = error.response && error.response.data;
        const readMessage =
          body instanceof Blob
            ? body.text().then((text) => {
                try {
                  return JSON.parse(text).message;
                } catch (e) {
                  return "";
                }
              })
            : Promise.resolve(body && body.message);
        return readMessage
          .catch(() => "")
          .then((message) => {
            commit("setError", message || label.caption.backupScriptError, {
              root: true,
            });
          });
      })
      .finally(() => {
        commit("setBackupExporting", false);
        commit("setLoadingBtn", false, { root: true });
      });
  },
};
